import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Chips } from "./Bits";

export const FEELS = ["Really good", "Good", "A little off", "Not good"];

export function RelationshipCheck({ fid, report, role, onDone }) {
  const existing = report.checks?.[role];
  const [feel, setFeel] = useState(existing?.feel || "");
  const [change, setChange] = useState(existing?.change || "");
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(!!existing);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/families/${fid}/reports/${report.id}/check`, { role, feel, change });
      setSaved(true);
      onDone?.(r.data);
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };

  return (
    <div data-testid={`relationship-check-${role}`} className="hf-card">
      <p className="hf-eyebrow">Relationship Check</p>
      <h3 className="mt-1 font-heading text-xl font-semibold">How did this visit feel?</h3>
      <div className="mt-4">
        <Chips options={FEELS} value={feel} onChange={setFeel} testid={`check-feel-${role}`} />
      </div>
      <label className="mt-6 block font-heading text-lg font-semibold">Anything to change next time?</label>
      <textarea
        data-testid={`check-change-${role}`}
        className="hf-input mt-2 min-h-[80px]"
        value={change}
        placeholder="Optional. Small things count."
        onChange={(e) => setChange(e.target.value)}
      />
      <button data-testid={`check-save-${role}`} disabled={!feel || busy} onClick={save} className="hf-btn hf-btn-primary mt-5 w-full">
        {saved ? "Update my answer" : "Share my answer"}
      </button>
      {saved && <p data-testid={`check-saved-${role}`} className="mt-3 text-center text-base text-hf-green">Thank you. Saved.</p>}
    </div>
  );
}
